import { useMemo } from 'react';
import { useScope } from '@workspace/scope-context';
import { useSession } from '@/context/SessionContext';

export function usePaymentsAccess() {
  const { session } = useSession();
  const { activeTenant } = useScope();

  return useMemo(() => {
    const tenantId = activeTenant?.id ?? '';
    const tenantPermissions = tenantId ? session?.permissionSummary?.tenants?.[tenantId] ?? [] : [];
    const globalPermissions = session?.permissionSummary?.global ?? [];
    const scopes = session?.scopes ?? [];
    const platformManage = globalPermissions.includes('platform.manage') || scopes.includes('platform.manage');
    const canManage = Boolean(tenantId) && (platformManage || tenantPermissions.includes('tenant.payments.manage') || scopes.includes('tenant.payments.manage'));
    const canView = Boolean(tenantId) && (canManage || tenantPermissions.includes('tenant.payments.view') || scopes.includes('tenant.payments.view'));
    return { tenantId, canView, canManage, accessEnabled: canView };
  }, [activeTenant?.id, session?.permissionSummary?.global, session?.permissionSummary?.tenants, session?.scopes]);
}
